<div class="overlay-panel">
  <p-overlayPanel #pOverlayPanel
                  [hideTransitionOptions]="'0ms'"
                  [styleClass]="styleClass"
                  [appendTo]="appendTo"
                  [dismissable]="dismissable"
                  (onHide)="onHidePanel()"
                  (onShow)="onShowPanel()">
    <ng-content></ng-content>
  </p-overlayPanel>
</div>
